"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidateCustomerDetails = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const CustomerDetailsFields_utils_1 = require("../../form/registration-fields/CustomerDetailsFields.utils");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const CheckoutDeliveryContext_1 = require("../../../context/CheckoutDeliveryContext");
const useValidateCustomerDetails = () => {
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.buy, i18nConstants_1.I18N_NAMESPACES.general]);
    const customerValues = (0, react_hook_form_1.useFormContext)().getValues('customer');
    const [showCustomerDetailsForm, setShowCustomerDetailsForm] = (0, react_1.useState)(!!customerValues);
    const shouldValidate = (0, react_1.useRef)(true);
    const [{ activeDeliveryOption }] = (0, CheckoutDeliveryContext_1.useDeliveryState)();
    (0, react_1.useEffect)(() => {
        shouldValidate.current = true;
    }, [activeDeliveryOption]);
    (0, react_1.useEffect)(() => {
        const validateForm = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (!customerValues || !Object.keys(customerValues).length) {
                return;
            }
            const isValid = yield (0, CustomerDetailsFields_utils_1.getCustomerDetailsValidationSchema)({ t }).isValid(customerValues);
            setShowCustomerDetailsForm(!isValid);
            shouldValidate.current = false;
        });
        shouldValidate.current && !showCustomerDetailsForm && validateForm();
    }, [customerValues, activeDeliveryOption]);
    const handleEdit = () => {
        setShowCustomerDetailsForm(true);
        shouldValidate.current = false;
    };
    return {
        showCustomerDetailsForm,
        handleEdit,
    };
};
exports.useValidateCustomerDetails = useValidateCustomerDetails;
